import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";

import "./index.css";

const container = document.getElementById("root");
// A hard failure rather than a silent no-op: the only way this is null is a broken index.html,
// and an app that renders nothing with no error is a worse ten minutes than an exception.
if (!container) throw new Error('No #root element — check index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
